import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "grid md:block md:flex gap-4" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid md:block md:flex gap-4" }
const _hoisted_6 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_7 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 176px)"}
}
const _hoisted_8 = { class: "custom-alert-title flex flex-col" }
const _hoisted_9 = { class: "ml-auto" }
const _hoisted_10 = { style: {"overflow-y":"auto","height":"calc(100vh - 226px)"} }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "alert-table hidden md:block w-full" }
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex w-full justify-end mt-4" }
const _hoisted_18 = { class: "hidden md:block mr-3" }
const _hoisted_19 = { class: "md:hidden" }
const _hoisted_20 = { class: "flex-col w-full px-2 justify-center items-center" }
const _hoisted_21 = { class: "flex flex-col md:flex-row" }
const _hoisted_22 = { class: "w-full md:w-1/2 md:px-2" }
const _hoisted_23 = { class: "w-full md:w-1/2 md:px-2" }
const _hoisted_24 = { class: "flex w-full items-center justify-center" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "el-upload-list__item-actions" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "dialog-footer" }
const _hoisted_30 = { class: "flex justify-center items-center" }
const _hoisted_31 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_AutoCompleteInput = _resolveComponent("AutoCompleteInput")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_MaterialSelect = _resolveComponent("MaterialSelect")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: _normalizeClass(["no-margin md:w-20 lg:w-44 xl:w-64", [
                                    _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                    _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                    '',
                                ]])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.searchForm.organization_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                            "is-search": true,
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["class"]), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                      ]),
                      _createVNode(_component_el_form_item, {
                        class: _normalizeClass(["no-margin", [
                                    _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                    _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                    'xl:w-64',
                                ]])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CategorySelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            "is-search": true,
                            modelValue: _ctx.searchForm.category_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                            placeholder: "カテゴリを選択"
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex", [
                                    _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                    _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                    'xl:w-64',
                                ]])
                      }, [
                        _createVNode(_component_el_form_item, { class: "no-margin flex flex-grow" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteInput, {
                              modelValue: _ctx.searchForm.material_name,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                              placeholder: "アイテム名を入力",
                              "storage-key": "material-name-history",
                              "max-history-items": 15,
                              ref: "materialNameInput"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          class: "md:hidden ml-3",
                          type: "primary",
                          onClick: _ctx.handleSearchButton,
                          circle: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 2),
                      _createVNode(_component_el_button, {
                        class: "hidden md:block w-24",
                        type: "primary",
                        onClick: _ctx.handleSearchButton
                      }, {
                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                          _createTextVNode("検索")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: _normalizeClass(["no-margin md:w-20 lg:w-44 xl:w-64", [
                                        _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                        _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                        '',
                                    ]])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrganizationSelect, {
                                modelValue: _ctx.searchForm.organization_id,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                                "is-search": true,
                                placeholder: "組織を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["class"]), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                          ]),
                          _createVNode(_component_el_form_item, {
                            class: _normalizeClass(["no-margin", [
                                        _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                        _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                        'xl:w-64',
                                    ]])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CategorySelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                "is-search": true,
                                modelValue: _ctx.searchForm.category_id,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                                placeholder: "カテゴリを選択"
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex", [
                                        _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:w-20' : 'md:w-36',
                                        _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'lg:w-44' : 'lg:w-64',
                                        'xl:w-64',
                                    ]])
                          }, [
                            _createVNode(_component_el_form_item, { class: "no-margin flex flex-grow" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AutoCompleteInput, {
                                  modelValue: _ctx.searchForm.material_name,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                                  placeholder: "アイテム名を入力",
                                  "storage-key": "material-name-history",
                                  "max-history-items": 15,
                                  ref: "materialNameInput"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              class: "md:hidden ml-3",
                              type: "primary",
                              onClick: _ctx.handleSearchButton,
                              circle: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 2),
                          _createVNode(_component_el_button, {
                            class: "hidden md:block w-24",
                            type: "primary",
                            onClick: _ctx.handleSearchButton
                          }, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode("検索")
                            ])),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  class: "custom-alert-icon-btn md:hidden",
                  type: "primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.drawer = true)),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "custom-alert-icon-btn md:hidden",
                  type: "primary",
                  onClick: _ctx.handleDelAllButton,
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " delete ", -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "hidden md:block w-24",
                  type: "primary",
                  onClick: _ctx.handleDelAllButton
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("全削除")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "custom-alert-icon-btn md:hidden",
                  type: "primary",
                  onClick: _ctx.handleExportButton,
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " download_2 ", -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "hidden md:block w-30",
                  type: "primary",
                  onClick: _ctx.handleExportButton
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode("CSVエクスポート")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[36] || (_cache[36] = _createElementVNode("span", null, "アラート（在庫数　品名　有効期間）", -1)),
                _createElementVNode("span", _hoisted_9, "アイテム数: " + _toDisplayString(_ctx.mTotalRecords), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    key: item.id,
                    style: _normalizeStyle([{"border":"1px solid #d1d5db","border-radius":"0px"}, { backgroundColor: new Date(item.expiration_date) < new Date() ? '#f3f3c1' : '' }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "w-8 h-16",
                                type: "primary",
                                style: {"background-color":"#c2dbf0"},
                                text: "",
                                bg: "",
                                onClick: ($event: any) => (_ctx.handleEditButton(item))
                              }, {
                                default: _withCtx(() => _cache[37] || (_cache[37] = [
                                  _createElementVNode("span", null, [
                                    _createTextVNode("詳"),
                                    _createElementVNode("br"),
                                    _createTextVNode("細")
                                  ], -1)
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 6,
                            class: "ml-2",
                            align: "middle"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: _normalizeClass(["text-6xl", { 'text-red-500': item.type === '在庫数' }])
                              }, _toDisplayString(item.quantity), 3)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 12,
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                              _createVNode(_component_el_row, { align: "middle" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["text-xl font-bold", { 'text-red-500': new Date(item.expiration_date) < new Date() }])
                                  }, _toDisplayString(item.expiration_date), 3),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["material-symbols-outlined cursor-pointer ml-4", { 'text-red-500': item.is_received != 1 }]),
                                    onClick: ($event: any) => (_ctx.handleSendButton(item))
                                  }, " drafts ", 10, _hoisted_11)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 2,
                            class: "ml-2",
                            align: "right"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "material-symbols-outlined cursor-pointer",
                                onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                              }, " delete ", 8, _hoisted_12)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: _ctx.mTableData,
                height: "calc(100vh - 230px)",
                "row-class-name": _ctx.tableRowClassName
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "アラート",
                    width: "80",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        class: "w-12",
                        type: "primary",
                        style: {"background-color":"#c2dbf0"},
                        text: "",
                        bg: "",
                        onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createElementVNode("span", null, "詳細", -1)
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        prop: "organization_name",
                        label: "組織",
                        width: "200"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_table_column, {
                    prop: "department_name",
                    label: "部門",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "material_name",
                    label: "アイテム名",
                    "min-width": "400"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.material_name), 1),
                      _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                      (scope.row.jancode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " （" + _toDisplayString(scope.row.jancode) + "） ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "category_name",
                    label: "カテゴリ",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "user_name",
                    label: "宛先",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "storage_date",
                    label: "保管日",
                    width: "100",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "expiration_date",
                    label: "有効期限",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'text-red-500': new Date(row.expiration_date) < new Date() })
                      }, _toDisplayString(row.expiration_date), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "quantity",
                    label: "在庫数",
                    width: "66",
                    "header-align": "center",
                    align: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'text-red-500': scope.row.type === '在庫数' })
                      }, _toDisplayString(scope.row.quantity), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "通知",
                    width: "52",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["material-symbols-outlined cursor-pointer mt-2", { 'text-red-500': scope.row.is_received != 1 }]),
                        onClick: ($event: any) => (_ctx.handleSendButton(scope.row))
                      }, " drafts ", 10, _hoisted_15)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "created_date",
                    label: "通知日",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'text-red-500': new Date(row.created_date) < new Date() })
                      }, _toDisplayString(row.created_date.slice(0, 10)), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "削除",
                    width: "52",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: "material-symbols-outlined cursor-pointer mt-2",
                        onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                      }, " delete ", 8, _hoisted_16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "row-class-name"])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.mCurrentPage,
                  "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                  "page-size": _ctx.mPageSize,
                  "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mPageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.mTotalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.mTotalRecords,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: "詳細",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_el_button, {
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[40] || (_cache[40] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
          }, {
            default: _withCtx(() => _cache[41] || (_cache[41] = [
              _createTextVNode(" 確認 ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            rules: _ctx.rules,
            ref: "formRef",
            "label-width": "auto"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "組織",
                        prop: "organization_id",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.form.organization_id,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.organization_id) = $event)),
                            disabled: _ctx.form.add_update === 'update',
                            onOrganizationNameChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.organization_name = $event)),
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "部門",
                        prop: "department_id",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.form.organization_id,
                            modelValue: _ctx.form.department_id,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.department_id) = $event)),
                            disabled: _ctx.form.add_update === 'update',
                            onDepartmentNameChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.department_name = $event)),
                            placeholder: "部門を選択"
                          }, null, 8, ["organization-id", "modelValue", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "カテゴリ",
                    prop: "category_id",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CategorySelect, {
                        "organization-id": _ctx.form.organization_id,
                        modelValue: _ctx.form.category_id,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.category_id) = $event)),
                        disabled: _ctx.form.add_update === 'update',
                        onCategoryNameChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.category_name = $event)),
                        placeholder: "カテゴリを選択"
                      }, null, 8, ["organization-id", "modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "アイテム名",
                    prop: "material_code",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MaterialSelect, {
                        "organization-id": _ctx.form.organization_id,
                        modelValue: _ctx.form.material_code,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.material_code) = $event)),
                        disabled: _ctx.form.add_update === 'update',
                        onMaterialNameChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.material_name = $event)),
                        placeholder: "アイテム名を選択"
                      }, null, 8, ["organization-id", "modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "在庫数",
                    prop: "quantity",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.form.quantity,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.quantity) = $event)),
                        min: 0,
                        max: 999999
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_el_form_item, {
                    label: "保管日",
                    prop: "storage_date"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.storage_date,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.storage_date) = $event)),
                        type: "date",
                        placeholder: "保管日を選択"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "有効期限",
                    prop: "expiration_date"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.expiration_date,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.expiration_date) = $event)),
                        type: "date",
                        placeholder: "有効期限を選択"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "保管場所",
                    prop: "location"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.location,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.location) = $event)),
                        autocomplete: "off",
                        placeholder: "保管場所を入力"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "コメント",
                    prop: "comment"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.comment,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.comment) = $event)),
                        autocomplete: "off",
                        placeholder: "コメントを入力"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_upload, {
              action: "#",
              "list-type": "picture-card",
              "auto-upload": false,
              "on-change": _ctx.handleImageChange,
              "on-remove": _ctx.handleRemove,
              limit: 3,
              "on-exceed": _ctx.handleExceed,
              "file-list": _ctx.fileList
            }, {
              file: _withCtx(({ file }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: ""
                  }, null, 8, _hoisted_25),
                  _createElementVNode("span", _hoisted_26, [
                    _createElementVNode("span", {
                      class: "el-upload-list__item-preview",
                      onClick: ($event: any) => (_ctx.handlePictureCardPreview(file))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_zoom_in)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_27),
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (_ctx.handleRemove(file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_28))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.fileList.length < 3)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["on-change", "on-remove", "on-exceed", "file-list"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("img", {
            "w-full": "",
            src: _ctx.dialogImageUrl,
            alt: "Preview Image"
          }, null, 8, _hoisted_31)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}